module.exports = "kan-partner-type-list-item .kan-partner-type-list-item {\n  font-size: 13px;\n  padding: 8px;\n  border: 1px solid #dddddd;\n  margin-bottom: -1px; }\n\nkan-partner-type-list-item:nth-child(even) {\n  background-color: #f9f9f9; }\n\nkan-partner-type-list-item:nth-child(odd) {\n  background-color: #ffffff; }\n\nkan-partner-type-list-item:last-child {\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/partner-type/list-item/component.scss
// module id = ./src/modules/admin/components/partner-type/list-item/component.scss
// module chunks = main